<script lang="ts">
import { onMount } from 'svelte'
import SoundsIcon from 'virtual:icons/lucide/bell-ring'
import TranscriptIcon from 'virtual:icons/lucide/download'
import GdprIcon from 'virtual:icons/lucide/shield-check'

import Drawer from '@/components/drawer/Drawer.svelte'
import DrawerContent from '@/components/drawer/DrawerContent.svelte'
import DrawerContentButton from '@/components/drawer/DrawerContentButton.svelte'
import DrawerContentSwitch from '@/components/drawer/DrawerContentSwitch.svelte'
import DrawerHeader from '@/components/drawer/DrawerHeader.svelte'
import { testIds } from '@/constants'
import { getNotificationSound, soundsEnabled, updateSoundsEnabled } from '@/modules/app'
import { closeDrawer, DrawerId, openDrawer } from '@/modules/drawers'
import { widgetOptions } from '@/modules/options'
import { getTranscript, shouldGetTranscript, transcriptProcessing } from '@/modules/transcript'
import { t } from '@/modules/translations'

const handleSounds = () => updateSoundsEnabled(!$soundsEnabled)
const openGdpr = () => openDrawer(DrawerId.GdprAndPrivacy)

onMount(() => {
	// pre-fetch notification sound, so it can be played without a delay
	void getNotificationSound()
})
const { transcriptEnabled } = widgetOptions.getOptions()
const { optionsPrivacyNotice, optionsSounds, optionsTranscript, optionsDrawer } = testIds
</script>

<Drawer onClose={closeDrawer} testId={optionsDrawer}>
	<DrawerHeader title={$t('options.title')} />
	<DrawerContent>
		<DrawerContentSwitch
			icon={SoundsIcon}
			text={$t('options.playSounds')}
			name="sounds"
			value={$soundsEnabled}
			onClick={handleSounds}
			testId={optionsSounds}
		/>
		{#if transcriptEnabled !== false}
			<DrawerContentButton
				icon={TranscriptIcon}
				text={$t('options.pdfTranscript')}
				onClick={getTranscript}
				testId={optionsTranscript}
				processing={$transcriptProcessing}
				buttonDisabled={!$shouldGetTranscript}
			/>
		{/if}
		<DrawerContentButton icon={GdprIcon} text={$t('options.gdpr')} onClick={openGdpr} testId={optionsPrivacyNotice} />
	</DrawerContent>
</Drawer>
